// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Glossary__toolbar___1S2Ju","backArrow":"Glossary__backArrow___1tiwa","title":"Glossary__title___3I7SS"};